module.exports = __webpack_public_path__ + "static/icon_play_clearbgv2.d18ed731.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_play_clearbgv2.png
// module id = 370
// module chunks = 35783957827783 114276838955818